window.movies = [];
window.updateRunning = false;
window.currentfocus = 'i_1_0';

window.apiHost = 'https://bahnwelt-tv.merl.ws';
//window.apiHost = 'http://bahnwelt-tv.ddev.site';


// Lodash
window._ = require('lodash');

// Fastclick
window.FastClick = require('fastclick');
FastClick.attach(document.body);

// Axios
window.axios = require('axios');

import {EventBus} from './lib/EventBus';
import * as config from './config';

var platformId = window.cordova.platformId;
if (platformId) {
    document.body.classList.add('is-' + platformId);
}

window.fetchMovies = function () {

    if ('onLine' in navigator && !navigator.onLine) {
        EventBus.$emit('notification', {message: config.MESSAGE_NOT_ONLINE});
        return [];
    }

    if (window.movies.length > 0) {
        return window.movies;
    }

    if (window.updateRunning) {
        return [];
    }

    window.updateRunning = true;

    window.axios({
        method: 'get',
        url: window.apiHost + '/api/list',
    })
        .then(function (response) {
            if (response.data && response.data.entries) {
                window.movies = response.data.entries;
                EventBus.$emit('receive-movies', window.movies);
            } else {
                EventBus.$emit('notification', {message: config.MESSAGE_SERVICE_NOT_AVAILABLE});
            }
            window.updateRunning = false;
        })
        .catch(function (error) {
            let message = (navigator.onLine) ? config.MESSAGE_SERVICE_NOT_AVAILABLE : config.MESSAGE_NOT_ONLINE;
            EventBus.$emit('notification', {message: message});
            window.updateRunning = false;
        });

    return [];
};

window.hasMovies = function () {
    return (window.movies.length > 0)
};

window.scrollToTop = function () {
    let page = document.getElementsByClassName('page')[0];
    if (page !== undefined) {
        page.scrollTo(0, 0);
    }

    let carousel = document.getElementsByClassName('carousel')[0];
    if (carousel !== undefined) {
        carousel.scrollTo(0, 0);
    }
};

window.addEventListener("orientationchange", orientationchange, false);
window.onload = orientationchange;

function orientationchange() {

    var physicalScreenWidth = window.screen.width * window.devicePixelRatio;
    var physicalScreenHeight = window.screen.height * window.devicePixelRatio;

    var ratio = physicalScreenWidth / physicalScreenHeight;

    // 16:9 always landscape
    if (ratio === 1.78) {
        screen.orientation.lock('landscape');
        return;
    }

    var originalMarginTop = document.body.style.marginTop;
    document.body.style.marginTop = "1px";

    if (Math.abs(window.orientation) === 90) {
        // Landscape
        document.body.classList.remove("portrait");
        document.body.classList.add("landscape");
    } else {
        // Portrait
        document.body.classList.remove("landscape");
        document.body.classList.add("portrait");
    }

    setTimeout(function () {
        document.body.style.marginTop = originalMarginTop;
    }, 0);
}

EventBus.$on('notification', (notification) => {
    setTimeout(function () {

        if (!notification.message) {
            return;
        }

        if (navigator.notification && navigator.notification.confirm) {

            if (!notification.title) {
                notification.title = 'Hinweis';
            }

            if (!notification.callback) {
                notification.callback = null;
            }

            if (!notification.buttons) {
                notification.buttons = ['OK'];
            }

            navigator.notification.confirm(
                notification.message,
                notification.callback,
                notification.title,
                notification.buttons
            );
        } else {
            alert(notification.message)
        }

    }, 250);
});




// WEBPACK FOOTER //
// ./src/bootstrap.js